import { render, staticRenderFns } from "./ScrollBar.vue?vue&type=template&id=7dafc094"
import script from "./ScrollBar.vue?vue&type=script&lang=js"
export * from "./ScrollBar.vue?vue&type=script&lang=js"
import style0 from "./ScrollBar.vue?vue&type=style&index=0&id=7dafc094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports